import { AnalyticsEventName } from '@/services/analytics/analytics.contract';
import { Component, Vue } from 'vue-property-decorator';
import { Routes } from '../router/routes';
import { AnalyticsEventCategory } from '../services/analytics/analytics.contract';

@Component({})
class GlobalMixin extends Vue {
  // Helper function for the track event directive
  public constructEvent = (name: AnalyticsEventName, category: AnalyticsEventCategory, label?: string) => ({
    name,
    category,
    label: label || '',
  });

  public get Routes() {
    return Routes;
  }

  public get AnalyticsEventNames() {
    return AnalyticsEventName;
  }

  public get AnalyticsEventCategories() {
    return AnalyticsEventCategory;
  }
}

Vue.mixin(GlobalMixin);
